<template>
    <div>
        <ModalCommon :id="`configModalCommon-${config?.id}`" :config="config" @save="handleSubmit()" @close="handleCloseModal()">
            <div>
                <b-tabs justified nav-class="nav-tabs-custom cus-document" content-class="p-3 text-muted">
                    <b-tab v-for="(tab, index) in tabSchedule" :key="index" class="border-0" :disabled="tab.disabled">
                        <template v-slot:title>
                            <span class="">{{ tab.name }}</span>
                        </template>
                        <div>
                            <div v-if="tab.id === 1">
                                <form class="needs-validation" autocomplete="off" @submit.prevent="handleSubmit" @keydown.enter.prevent>
                                    <div class="form-group row mb-3">
                                        <label class="col-sm-2">{{ $t('sheduleFile.startDateCP') }} <span class="text-danger">*</span></label>
                                        <div class="col-sm-9 pl-0">
                                            {{ formatDateCommon(initForm.start_date_cp_full_date, 'dateTimeJP') ?? '' }}
                                        </div>
                                    </div>

                                    <div class="form-group row mb-3">
                                        <label class="col-sm-2">{{ $t('sheduleFile.endDateCP') }} <span class="text-danger">*</span></label>
                                        <div class="col-sm-9 pl-0">
                                            {{ formatDateCommon(initForm.end_date_cp_full_date, 'dateTimeJP') ?? '' }}
                                        </div>
                                    </div>

                                    <div class="form-group row mb-3">
                                        <label class="col-sm-2">{{ $t('sheduleFile.dateShipping') }} <span class="text-danger">*</span></label>
                                        <div class="col-sm-9 pl-0">
                                            <DateNormal
                                                :id="`select-date_shipping`"
                                                :year.sync="initForm.date_shipping_year"
                                                :month.sync="initForm.date_shipping_month"
                                                :day.sync="initForm.date_shipping_day"
                                                :full_date.sync="initForm.date_shipping_full_date"
                                                :config.sync="initForm.configFieldDateShipping"
                                                @blur="handleValidateField(initForm.configFieldDateShipping, 'date-shipping')"
                                            >
                                                <div v-if="initForm.configFieldDateShipping.error" class="invalid-feedback d-block">
                                                    <span>{{ initForm.configFieldDateShipping.errorText }}</span>
                                                </div>
                                            </DateNormal>
                                        </div>
                                    </div>

                                    <div class="form-group row mb-3">
                                        <label class="col-sm-2">{{ $t('sheduleFile.endDateSecretariat') }} <span class="text-danger">*</span></label>
                                        <div class="col-sm-9 pl-0">
                                            {{ formatDateCommon(initForm.end_date_secretariat_full_date, 'dateTimeJP') ?? '' }}
                                        </div>
                                    </div>

                                    <div class="form-group row mb-3">
                                        <label class="col-sm-2">{{ $t('sheduleFile.typeApplication') }}</label>
                                        <div class="col-sm-9 pl-0">
                                            <div class="d-flex flex-wrap">
                                                <div v-for="item in initForm.listApplication" :key="item.id + 's'">
                                                    <InputCheckBox
                                                        class="mr-3 mb-2"
                                                        :model.sync="initForm.type_application"
                                                        :id="`check-type_application${item.id}`"
                                                        :value="item.id"
                                                        :label="item.value"
                                                        @change="handleChangeTypeApplication(item.id)"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-group row mb-3">
                                        <div class="table-responsive" style="height: 390px; overflow-y: auto">
                                            <table class="table mb-0 table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th colspan="1" rowspan="3">
                                                            {{ $t('sheduleFile.conditionExport') }}
                                                        </th>
                                                        <th colspan="1" rowspan="3" style="width: 120px">
                                                            <div class="">
                                                                <InputCheckBox
                                                                    :model.sync="checkAll"
                                                                    :id="`check-all`"
                                                                    :value="checkAll"
                                                                    :label="$t('pageCampaign.checkAll')"
                                                                    @change="handleCheckAll"
                                                                />
                                                            </div>
                                                        </th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <template v-for="(itemT1, indexT1) in listDataType1">
                                                        <tr v-for="(ws, idx) in itemT1.works" :key="`${indexT1}-${idx}-type1`">
                                                            <td v-if="idx === 0" :rowspan="itemT1.works.length" style="width: 450px">
                                                                {{ itemT1.title }}
                                                            </td>
                                                            <td class="text-center">
                                                                <div class="row-data-small">
                                                                    <InputCheckBox
                                                                        :model.sync="ws.checked"
                                                                        :id="`check-checked${indexT1}-${idx}`"
                                                                        :value="ws.checked"
                                                                        :label="``"
                                                                        @change="handleCheckData"
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="row-data-small">
                                                                    {{ ws.work_title ? ws.work_title : '' }}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </template>

                                                    <template v-for="(itemT2, indexT2) in listDataType2">
                                                        <tr v-for="(ws, idx) in itemT2.works" :key="`${indexT2}-${idx}-type2`">
                                                            <td v-if="idx === 0" :rowspan="itemT2.works.length">
                                                                {{ itemT2.title }}
                                                            </td>
                                                            <td class="text-center">
                                                                <div class="row-data-small">
                                                                    <InputCheckBox
                                                                        :model.sync="ws.checked"
                                                                        :id="`check-indexT2${indexT2}-${idx}`"
                                                                        :value="ws.checked"
                                                                        :label="``"
                                                                        @change="handleCheckData"
                                                                    />
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div class="row-data-small">
                                                                    {{ ws.work_title ? ws.work_title : '' }}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </template>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <TabConditionFMT v-if="tab.id === 2" :fmtConfig="config" @dataTabFMT="scheduleTabFMT = $event" />
                            <TabContactFMT v-if="tab.id === 3" :contactFmtConfig="config" @dataTabContactFMT="scheduleTabContactFMT = $event" />
                        </div>
                    </b-tab>
                </b-tabs>
            </div>
        </ModalCommon>
    </div>
</template>

<script>
import DateNormal from '@/components/DateCustoms/DateNormal/main.vue';
import ModalCommon from '@/components/Modal/main.vue';
import TabConditionFMT from './tab-fmt/main.vue';
import TabContactFMT from './tab-contact-fmt/main.vue';

import { InputCheckBox } from '@/components/Input';
import { handleValidate, initForm, validateEndDate, TAB_SCHEDULE } from './index';
import { formatDateCommon } from '@/utils/format';
import { validateField } from '@/utils/validate';
import { showMessage } from '@/utils/messages';
import { masterMethods, campaignMethods } from '@/state/helpers';

export default {
    name: 'PopUpSchedule',
    props: {
        config: {
            type: Object,
            required: false
        },
        masterDataType1: {
            default: () => []
        },
        masterDataPlatform: {
            default: () => []
        }
    },
    components: {
        DateNormal,
        ModalCommon,
        InputCheckBox,
        TabConditionFMT,
        TabContactFMT
    },
    data() {
        return {
            initForm: initForm(),
            listDataType1: this.masterDataType1,
            listDataPlatform: this.masterDataPlatform,
            listDataType2: [],
            tabSchedule: TAB_SCHEDULE(),
            scheduleTabFMT: null,
            scheduleTabContactFMT: null,
            checkAll: false
        };
    },
    methods: {
        ...masterMethods,
        ...campaignMethods,
        formatDateCommon,
        handleCheckAll() {
            this.listDataType1.forEach((parent) => {
                parent.works.forEach((child) => {
                    child.checked = this.checkAll;
                });
            });
            this.listDataType2.forEach((parent) => {
                parent.works.forEach((child) => {
                    child.checked = this.checkAll;
                });
            });
        },
        handleCheckData() {
            const checkedType1 = this.listDataType1.map((item) => item.works.filter((ws) => ws.checked).map((ws) => ws.id));
            const checkedType2 = this.listDataType2.map((item) => item.works.filter((ws) => ws.checked).map((ws) => ws.id));
            const listWorksType1 = this.listDataType1.map((item) => item.works);
            const listWorksType2 = this.listDataType2.map((item) => item.works);
            this.checkAll = [...checkedType1, ...checkedType2].flat().length === [...listWorksType1, ...listWorksType2].flat().length;
        },

        handleValidateField(configField, action = null) {
            validateField(configField);
            if (action == 'compare-date') {
                validateEndDate(
                    this.initForm.configFieldEndDate,
                    this.initForm.configFieldStartDate.valueSync,
                    this.initForm.configFieldEndDate.valueSync
                );
            }
        },

        handleClearData() {
            this.initForm = initForm();
        },

        handleChangeTypeApplication(id) {
            this.handleDataCommon('change', id);
        },

        handleCloseModal() {
            this.handleClearData();
        },

        handleCheckedApplicationType1() {
            if (this.config.listIDWorks?.length <= 0) return;
            this.listDataType1.forEach((parent) => {
                parent.works.forEach((child) => {
                    child.checked = this.config.listIDWorks.includes(child.id);
                });
            });
        },

        handleDataCommon(type, id) {
            this.listDataType2 = [];
            this.listDataPlatform.forEach((parent) => {
                parent.platforms.forEach((child) => {
                    if (id && !this.initForm.type_application.includes(id)) {
                        if (child.id === id) {
                            const mapData = parent.platforms.map((p) => p.id);
                            const isSome = mapData.some((item) => this.initForm.type_application.includes(item));
                            if (isSome) return;
                            parent.works.forEach((ws) => {
                                ws.checked = false;
                            });
                        }
                    }

                    if (this.initForm.type_application.includes(child.id)) {
                        if (!this.listDataType2.some((item) => item.id === parent.id)) {
                            if (type !== 'change' && this.config.listIDWorks?.length > 0) {
                                parent.works.forEach((ws) => {
                                    ws.checked = this.config.listIDWorks.includes(ws.id);
                                });
                            }
                            this.listDataType2.push(parent);
                        }
                    }
                });
            });
        },

        async handleSaveRulePayLoad() {
            let dataPayload = {
                campaign_id: this.config.dataDocument.id ?? null,
                source: this.config.source.source ?? null,
                data: {
                    date_shipping: this.initForm.date_shipping_full_date
                }
            };
            try {
                await this.postRuleSavePayLoad(dataPayload);
            } catch (error) {
                console.log('error', error);
            }
        },

        handleSubmit() {
            let check = handleValidate(this.initForm);
            if (!check && this.initForm.date_shipping_full_date === '') {
                showMessage(8080, this.$bvToast, this.$t('document.msgDateShippingSchedule'));
            }
            if (!check) return;
            const checkedType1 = this.listDataType1.map((item) => item.works.filter((ws) => ws.checked).map((ws) => ws.id));
            const checkedType2 = this.listDataType2.map((item) => item.works.filter((ws) => ws.checked).map((ws) => ws.id));
            if ([...checkedType1, ...checkedType2].flat().length <= 0) {
                showMessage(8080, this.$bvToast, this.$t('document.msgSettingSchedule'));
                return;
            }
            let { closing_date, report_date, cycle, skip_the_first_week_closing, include_it_one_week_before } = this.scheduleTabFMT;
            let objSchedule = {
                parentID: this.config.code,
                titles: [...checkedType1, ...checkedType2].flat(),
                campaign_start_date: this.initForm.start_date_cp_full_date,
                campaign_end_date: this.initForm.end_date_cp_full_date,
                date_shipping: this.initForm.date_shipping_full_date,
                secretariat_end_date: this.initForm.end_date_secretariat_full_date,
                categories: this.initForm.type_application.map((item) => {
                    return {
                        category_id: item
                    };
                }),
                fmt_parameter_settings: this.config.dataDocument.has_fmt_parameter
                    ? {
                          delivery_cycle: cycle,
                          closing_day: closing_date,
                          report_day: report_date,
                          is_skip_the_first_week: skip_the_first_week_closing,
                          is_merged_with_the_last_week: include_it_one_week_before
                      }
                    : null,
                fmt_contact_agency_settings: this.config.dataDocument.has_fmt_contact
                    ? {
                          delivery_cycle: this.scheduleTabContactFMT.cycle,
                          closing_day: this.scheduleTabContactFMT.closing_date,
                          report_day: this.scheduleTabContactFMT.report_date,
                          is_skip_the_first_week: this.scheduleTabContactFMT.skip_the_first_week_closing,
                          is_merged_with_the_last_week: this.scheduleTabContactFMT.include_it_one_week_before
                      }
                    : null
            };
            this.actionDataParamaterFMT(this.scheduleTabFMT);
            this.actionDataContactFMT(this.scheduleTabContactFMT);
            this.$emit('update:exportSchedule', objSchedule);
            this.$props.config.model = false;
            this.handleSaveRulePayLoad(objSchedule);
        }
    },
    watch: {
        config: {
            async handler() {
                const dataGetPayload = await this.getRuleSavePayLoad({ campaign_id: this.config.dataDocument.id, source: this.config.source.source });
                let shippingDate = dataGetPayload?.data?.payload?.date_shipping
                    ? dataGetPayload.data.payload.date_shipping
                    : this.config.dateShipping;

                this.tabSchedule = this.tabSchedule.map((item) => {
                    if (item.name === this.$t('document.contactFMT') && !this.config.dataDocument.has_fmt_contact) {
                        item.disabled = true;
                    }
                    if (item.name === this.$t('document.mumberOfMessagesFMT') && !this.config.dataDocument.has_fmt_parameter) {
                        item.disabled = true;
                    }
                    return item;
                });

                let handleData = this.config.dataCPType.find((item) => {
                    return item.id === this.config.dataDocument.campaign_type?.id;
                });
                this.initForm = {
                    ...this.initForm,
                    start_date_cp_full_time: formatDateCommon(this.config.dataDocument.campaign_start_date, 'dateTime') ?? '',
                    end_date_cp_full_time: formatDateCommon(this.config.dataDocument.campaign_end_date, 'dateTime') ?? '',
                    end_date_secretariat_full_time: formatDateCommon(this.config.dataDocument.secretariat_end_date, 'dateTime') ?? '',
                    start_date_cp_full_date: formatDateCommon(this.config.dataDocument.campaign_start_date, 'date') ?? '',
                    end_date_cp_full_date: formatDateCommon(this.config.dataDocument.campaign_end_date, 'date') ?? '',
                    date_shipping_full_date: formatDateCommon(shippingDate, 'date') ?? '',
                    end_date_secretariat_full_date: formatDateCommon(this.config.dataDocument.secretariat_end_date, 'date') ?? '',
                    configFieldStartDate: {
                        ...this.initForm.configFieldStartDate,
                        valueSync: `${formatDateCommon(this.config.dataDocument.campaign_start_date, 'date') ?? ''} ${formatDateCommon(this.config.dataDocument.campaign_start_date, 'dateTime')}`
                    },
                    configFieldEndDate: {
                        ...this.initForm.configFieldEndDate,
                        valueSync: `${formatDateCommon(this.config.dataDocument.campaign_end_date, 'date') ?? ''} ${formatDateCommon(this.config.dataDocument.campaign_end_date, 'dateTime')}`
                    },
                    configFieldEndDateSecretariat: {
                        ...this.initForm.configFieldEndDateSecretariat,
                        valueSync: `${formatDateCommon(this.config.dataDocument.secretariat_end_date, 'date') ?? ''} ${formatDateCommon(this.config.dataDocument.secretariat_end_date, 'dateTime')}`
                    },

                    listApplication: handleData?.data?.map((item) => {
                        return {
                            id: item.id,
                            value: item.value
                        };
                    }),
                    type_application: this.config.dataDocument?.categories?.map((item) => item.category_id)
                };
                this.handleCheckedApplicationType1();
                this.handleDataCommon('config', null);
            },
            deep: true
        },

        masterDataType1: {
            handler: function (newData) {
                this.listDataType1 = newData;
            },
            immediate: true
        },
        masterDataPlatform: {
            handler: function (newData) {
                this.listDataPlatform = newData;
            },
            immediate: true
        }
    }
};
</script>

<style lang="scss" scoped></style>
